import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  public query: any = {};
  public filters: any[] = [];

  public text: string = null;

  public amount: number = null;
  private greaterThan: number = null;
  private lesserThan: number = null;

  private ignored: boolean = false;
  private internal: boolean = false;

  private proven: boolean = false;
  private unknown: boolean = false;

  public currentDate: Date = null;
  public startDate: Date = null;
  public endDate: Date = null;

  public limit: number = 0; 

  private listeners: any[] = [];

  constructor() { }

  reset() {
    this.text = null;
    this.greaterThan = undefined;
    this.lesserThan = undefined;
    this.amount = undefined;
    this.ignored = false;
    this.internal = false;
    this.unknown = false;
    this.proven = false;
    this.limit = 0;

    this.query = {};
  }


  applyFilters(query = null) {

    if (query === null) {
      query = this.query;
    }
   
    if (!this.ignored) {
      query['ignore'] = {
        '$in': [null, false]
      };
    }

    if (!this.internal) {
      query['internal'] = {
        '$in': [null, false]
      };
    }

    query['status'] = {
      '$in': []
    };

    if (this.proven) {
      query['status']['$in'].push("proven");
    }

    if (this.unknown) {
      query['status']['$in'].push("unknown");
    }

    if (this.internal) {
      query['status']['$in'].push("internal");
    }

    if (this.lesserThan !== undefined) {
      query['amount'] = {
        '$lte': this.lesserThan
      }
    }

    if (this.greaterThan !== undefined) {
      query['amount'] = {
        '$gte': this.greaterThan
      }
    }

    if (this.amount !== undefined) {
      query['$or'] = [
        {amount: this.amount},
        { amount: this.amount*-1 }
      ];

      this.removeDateRange();
    }

    if (this.text != null) {
      query['$text'] = { $search: this.text };
    }

    this.query = query;

    for (let i=0;i<this.listeners.length;i++) {
      this.listeners[i]();
    }
  }

  searchText(text: string) {
    this.text = text;
  }

  dateRange(start: Date | null, end: Date | null = null) {

    let temp: any = {};

    if (start != null) {
      temp["$gte"] = start;
    }

    if (end != null) {
      temp["$lte"] = end;
    }

    this.query["date"] = temp;
  }
  
  weekRange(offset) {
    let date = new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 7 * offset))

    let first = setToMonday(date);
    first.setHours(0,0,0,0);

    let last = new Date(first.getTime());
    last.setDate(first.getDate() + 6); // last day is the first day + 6
    last.setHours(23,59,59);

    this.startDate = first;
    this.endDate = last;

    this.dateRange(this.startDate, this.endDate)
  }

  setAmount (amount: number|string, isCredit=true) {
    if (typeof(amount) == 'string') {
      amount = Number.parseInt(amount);
    }

    if (!isCredit && amount > 0) {
      amount = amount * -1;
    }

    this.amount = amount;
  }

  isGreaterThan(amount: number) {
    this.filters.push({
      type: "greaterThanAmount",
      value: amount
    })

    this.greaterThan = amount;
  }

  isLesserThan(amount: number) {
    this.filters.push({
      type: "lesserThanAmount",
      value: amount
    })

    this.lesserThan = amount;
  }

  onlyCredits () {
    this.greaterThan = 0;
    this.lesserThan = undefined;
  }

  onlyDebits () {
    this.lesserThan = 0;
    this.greaterThan = undefined;
  }

  onlyIgnored() {
    this.ignored = true;
    this.internal = false;
    this.unknown = false;
    this.proven = false;
  }

  onlyUnknown() {
    this.unknown = true;
    this.proven = false;
  }

  onChange(func: any) {
    this.listeners.push(func);
  }

  onChangeClear() {
    this.listeners = [];
  }

  showIgnored() {
    this.ignored = true;
  }

  showInternal() {
    this.internal = true;
  }

  showUnknown() {
    this.unknown = true;
  }

  showProven() {
    this.proven = true;
  }

  hideProven() {
    this.proven = false;
  }

  applyDateRange(start: Date, end: Date) {
    let dateQuery: any = {};

    if (start != null) {
      dateQuery["$gte"] = start;
    }

    if (end != null) {
      dateQuery["$lte"] = end;
    }

    this.query['date'] = dateQuery;
  }

  removeDateRange() {
    delete this.query["date"];
  }

  financialYear(start: string, end: string) {
    this.applyDateRange(new Date(start), new Date(end));
  }

  thisWeek() {
    let curr = new Date; // get current date
    let first = curr.getDate() - curr.getDay()+1; // First day is the day of the month - the day of the week
    let last = first + 6; // last day is the first day + 6
    

    let firstDay = new Date(curr.setDate(first));
    let lastDay = new Date(curr.setDate(last));

    // reset time
    firstDay.setHours(0,0,0);
    lastDay.setHours(0,0,0);

    this.applyDateRange(firstDay, lastDay);
  }

  lastWeek() {
    let curr = new Date; // get current date
    let first = curr.getDate() - curr.getDay()+1; // First day is the day of the month - the day of the week
    let last = first + 6; // last day is the first day + 6
    
    first -= 7;
    last -= 7;

    let firstDay = new Date(curr.setDate(first));
    let lastDay = new Date(curr.setDate(last));

    // reset time
    firstDay.setHours(0,0,0);
    lastDay.setHours(0,0,0);

    this.applyDateRange(firstDay, lastDay);
  }

  thisMonth() {
    let date = new Date();
    this.applyDateRange(new Date(date.getFullYear(), date.getMonth(), 1), new Date(date.getFullYear(), date.getMonth()+1, 0))
  }
}

function setToMonday( date: Date ): Date {
  var day = date.getDay() || 7;  
  if( day !== 1 ) 
      date.setHours(-24 * (day - 1)); 
  return date;
}